<template>
  <div class="myhomepage">
    <div class="header">
      <p class="logobox"></p>
     <!-- <p>{{chname}}</p> -->
      <router-link
        class="iconfont icon-back1"
        :to="{ name: 'newlist', query: { nowkey: nowkey, nowindex: nowindex } }"
        >返回列表</router-link
      >
    </div>
    <div class="mymsgbox">
      <template v-for="(imglistdata, key, index1) in imglists">
        <template v-for="(value, index) in imglistdata">
          <template v-if="value.name == num">
            <div :key="index">
              <div class="mytitle">
                {{ value.chname }}{{ getweizhi(key, index,value.chname) }}
              </div>
              <div class="audiobox">
                <audio
                  autoplay="autoplay"
                  loop="loop"
                  preload="auto"
                  id="myaudio"
                  :src="getaudio(value.name, value)"
                  @canplay="canplayf"
                  @timeupdate="timeupdatef"
                ></audio>
                <i
                  class="iconfont icon-bofang"
                  id="imgcontrol"
                  :class="isplay == 0 ? 'icon-bofang' : 'icon-zhanting'"
                  @click="playaudio"
                ></i>
                <div class="jindu">
                  <div :style="{ width: nowWidth }">
                    <span class="yuan"></span>
                  </div>
                  <p class="qstime">
                    {{ qstime }}
                  </p>
                  <p class="endtime">
                    {{ endtime }}
                  </p>
                </div>
              </div>
              <img :src="value.img" alt="" class="myimg" />
              <div class="mycontent">
                <div v-html="repSign(item)" v-for="item in value.text"></div>
              </div>
              <div class="myfanyebox">
                <div class="myprev" @click="prev(imglistdata[index - 1].name)">
                  <span class="sp1">上一篇：</span
                  ><span v-if="index != 0">{{
                    imglistdata[index - 1].chname | valfilter(6)
                  }}</span
                  ><span v-if="index == 0">无</span>
                </div>
                <div class="mynext" @click="next(imglistdata[index + 1].name)">
                  <span class="sp1">下一篇：</span
                  ><span v-if="index != imglistdata.length - 1">{{
                    imglistdata[index + 1].chname | valfilter(6)
                  }}</span
                  ><span v-if="index == imglistdata.length - 1">无</span>
                </div>
              </div>
            </div>
          </template>
        </template>
      </template>
      <div class="mycontact">
        <div>咨询电话：<a href="tel:0830-6510908">0830-6510908</a></div>
        <div>投诉电话：<a href="tel:0830-6510968">0830-6510968</a></div>
        <div>救援电话：<a href="tel:0830-6510908">0830-6510908</a></div>
        <div>全国旅游服务监管平台：<a href="tel:12345">12345</a></div>
        <!-- <div>官方网站：www.syhhjq.cn</div> -->
        <div>微信公众号：泸顺馆</div>
        <div>陈列馆地址： 泸州市怡景路2号1幢</div>
        <p class="myfooter">技术支持：至上互动</p>
        <!-- <img src="../assets/img/qrcode.jpg" alt="" class="myerqode" /> -->
      </div>
    </div>
    <div class="mengban" v-if="anum == 1" @touchstart="toplayau()"></div>
  </div>
</template>
<script>
export default {
  data() {
    let query = this.$route.query;
    let num = "0001";
    if (query.a) {
      num = query.a;
    } else {
    }

    return {
      imglist: [],
      alldatas: alldatas,
      num: num,
      audio: "",
      audiourl: "",
      isplay: 0,
      imglists: {},
      qstime: "00:00",
      endtime: "00:00",
      alltime: "",
      nowWidth: 0,
      nowkey: "",
      nowindex: "",
      anum: 1,
      trTimer: "",
      chname: "",
    };
  },
  components: {},
  computed: {},
  methods: {
    getweizhi(key, index,chname) {
      this.nowkey = key;
      this.nowindex = index;
      this.chname=chname
      return "";
    },
    timeupdatef() {
      let audioPlayer = document.getElementById("myaudio");
      this.qstime = this.timeToStr(audioPlayer.currentTime);
      let baifenbi = (audioPlayer.currentTime / this.alltime) * 100;
      this.nowWidth = baifenbi.toFixed(2) + "%";
    },
    canplayf() {
      let audioPlayer = document.getElementById("myaudio");
      this.endtime = this.timeToStr(audioPlayer.duration);
      this.alltime = audioPlayer.duration;
    },
    timeToStr(time) {
      var m = 0,
        s = 0,
        _m = "00",
        _s = "00";
      m = Math.floor(time / 60);
      s = Math.floor(time % 60);
      _s = s < 10 ? "0" + s : s + "";
      _m = m < 10 ? "0" + m : m + "";
      return _m + ":" + _s;
    },
    prev(name) {
      this.num = name;
      this.fy();
    },
    next(name) {
      this.num = name;
      this.fy();
    },
    fy() {
      //    this.playaudio()
    },
    toplayau() {
      let audioPlayer = document.getElementById("myaudio");
      if (audioPlayer) {
        if (audioPlayer.paused) {
          audioPlayer.play();
          this.isplay = 1;
        } else {
        }
      } else {
      }
      this.anum = 0;
    },
    playaudio() {
      let audioPlayer = document.getElementById("myaudio");
      if (audioPlayer) {
        this.isplay = 0;
        if (audioPlayer.paused) {
          audioPlayer.play();
          this.isplay = 1;
        } else {
          audioPlayer.pause();
          this.isplay = 0;
        }
      }
    },
    getaudio(name, val) {
      let url;
      this.audiolist.forEach((item, index) => {
        if (item.audio.indexOf(name) != -1) {
          url = item.audio;
        }
      });
      this.audiourl = url;
      return url;
    },
    repSign(s) {
      s = s.replace(
        /([\u4E00-\u9FA5]|^|\n|\r)([\,\.\?\!])(?=[\u4E00-\u9FA5]|$|\n|\r)/g,
        function(u, v, w, x) {
          let sign = {
            ",": "，",
            ".": "。",
            "?": "？",
            "!": "！"
          };
          return sign[w] ? v + sign[w] : u;
        }
      );
      return s;
    }
  },
  filters: {
    valfilter(val, num) {
      if (!val) return "";
      if (val.length > num) {
        return val.slice(0, num) + "...";
      }
      return val;
    }
  },
  created() {
    let imglists={
        'XZ':[],
        'A':[],
        'B':[],
        'C':[],
    };
    const files = require
      .context("@/assets/img/audioimg", true, /\.*\.jpg|jpeg|png$/)
      .keys();
    files.forEach(e => {
      let nn = e.slice(2).split("-");
      for (let key in this.alldatas) {
        let chname;
        let size;
        let textList;
        this.alldatas[key].forEach((item, index) => {
          if (nn[0] == item.number) {
            chname = item.name;
            textList = item.text;
            if (item.size) {
              size = item.size;
            } else {
              size = "";
            }
          }
        });
        if (!chname) {
          // console.log(nn[0])
        } else {
          if (textList.length > 0) {
            imglists[key].push({
              img: require("@/assets/img/audioimg" + e.slice(1)),
              name: nn[0],
              chname: chname,
              text: textList,
              size: "<p>" + size + "</p>"
            });
          }
        }
      }
    });
    this.imglists = imglists;
    let audiolist = [];
    const files1 = require.context("@/assets/audio", true, /\.*\.mp3$/).keys();
    files1.forEach(e => {
      audiolist.push({
        audio: require("@/assets/audio" + e.slice(1))
      });
    });
    this.audiolist = audiolist;
    //console.log(audiolist)触摸屏
  },
  watch: {},
  mounted() {
    this.trTimer = setTimeout(this.playaudio(), 100);
  },
  beforeDestroy() {
    clearInterval(this.trTimer);
  }
};
</script>
<style>
.mengban {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 99;
}
.myhomepage {
  width: 100%;
  height: 100vh;
  overflow: auto;
}
.header {
  width: 100%;
  height: 11.5vw;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #fff;
  justify-content: center;
  font-size: 4.2vw;
  font-weight: bold;
}
.header .iconfont {
  font-size: 18px;
}
.logobox {
  width: 15vw;
  height: 100%;
  background-image: url(../assets/img/logo.png);
  background-size: 10vw auto;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  right: 0;
  top: 0;
}
.header > a {
  position: absolute;
  left: 1vw;
  top: 3vw;
  font-size: 6vw;
  color: #666;
}
.mymsgbox {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mytitle {
  font-size: 5.8vw;
  width: 90vw;
  margin-top: 2vw;
}
.audiobox {
  height: 16.4vw;
  width: 86.2vw;
  display: flex;
}
#imgcontrol {
  height: 8.4vw;
  width: 8.4vw;
  border-radius: 50%;
  background-color: #e53c38;
  color: #fff;
  font-size: 3.6vw;
  text-align: center;
  line-height: 8.4vw;
  margin-left: 2.8vw;
  margin-top: 3.4vw;
}
.jindu {
  width: 70vw;
  height: 0.4vw;
  background-color: #a8a8a8;
  border-radius: 0.2vw;
  margin-top: 6.2vw;
  margin-left: 3.5vw;
  position: relative;
}
.jindu > div {
  height: 100%;
  background-color: #e53c38;
  position: relative;
  width: 0;
}
.yuan {
  width: 3.2vw;
  height: 3.2vw;
  border-radius: 50%;
  background-color: #e53c38;
  top: 50%;
  left: 100%;
  transform: translate(-50%, -50%);
  position: absolute;
}
.jindu > p {
  font-size: 2.2vw;
  color: #9d9d9d;
  position: absolute;
  top: 4.8vw;
}
.qstime {
  left: 0;
}
.endtime {
  right: 0;
}
.myimg {
  width: 92.4vw;
  /* height: 57.5vw;
        background-size: cover;
        background-position: center bottom; */
}
.mycontent {
  margin-top: 3vw;
  width: 92.4vw;
  color: #666666;
  font-size: 3.46vw;
  line-height: 6.5vw;
  text-indent: 2em;
}
.myfanyebox {
  width: 92.4vw;
  height: 13vw;
  margin-top: 2.5vw;
  display: flex;
  justify-content: space-between;
  font-size: 3.46vw;
  color: #333333;
}
.myfanyebox > div {
  width: 45vw;
  height: 100%;
  border-radius: 6.6vw;
  border: 1px solid #707070;
  line-height: 13vw;
}
.sp1 {
  margin-left: 2.8vw;
}
.mycontact {
  width: 92.4vw;
  display: flex;
  flex-direction: column;
  /* background-image: url(../assets/img/code.jpg);
        background-size: 27.4vw 27.4vw;
        background-repeat: no-repeat;
        background-position: right top; */
  color: #333333;
  font-size: 3.466vw;
  margin-top: 5vw;
  position: relative;
}
.myerqode {
  width: 27.4vw;
  height: 27.4vw;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 99;
}
.mycontact > div {
  margin-bottom: 2.6vw;
}
.mycontact a {
  color: #333333;
  font-size: 3.466vw;
}
.mycontact > p {
  text-align: center;
  margin-top: 2.8vw;
  margin-bottom: 7vw;
}
</style>



// WEBPACK FOOTER //
// src/view/Home.vue